export const routes = [
    {
        path: '/',
        component: () => import('@/layouts/MainLayout.vue'),
        children: [
            {
                path: '',
                name: '/home',
                component: () => import('@/views/Home.vue'),
                meta: {
                    title: 'Avenir Software - HVAC Software Solutions',
                    metaTags: [
                        { name: 'description', content: 'Design software for HVAC/P. LoopCAD for radiant heating, HeatCAD for heating load, and PlumbingCAD for plumbing takeoffs.Supports Manual J, Verified F280 and ASHRAE.' },
                        { name: 'keywords', content: 'avenir, software, heating design, HVAC, radiant heating design, plumbing design, loopcad, heatcad, plumbingcad, heat loss, heat gain, cooling, plumbing takeoffs, calculations, manual j, f280, csa, pex, autocad, ashrae, acca approved' },
                    ],
                },
            },
            {
                path: '/login',
                name: '/login',
                props: true,
                component: () => import('@/components/Login.vue'),
            },
            {
                path: '/myaccount/:page',
                name: '/myaccount',
                props: true,
                meta: {
                    title: 'Avenir Software Inc. - My Account',
                    requiresAuth: true,
                    sitemap: { ignoreRoute: true },
                    name: 'robots', content: 'noindex, nofollow',
                },
                component: () => import('@/views/MyAccount/MyAccount.vue'),
            },
            {
                path: '/myaccount/orders/order-details/:id',
                name: '/myaccount/orders/order-details',
                props: true,
                meta: {
                    title: 'Avenir Software Inc. - Order Details',
                    requiresAuth: true,
                    sitemap: { ignoreRoute: true },
                    name: 'robots', content: 'noindex, nofollow',
                },
                component: () => import('@/views/MyAccount/OrderDetails.vue'),
            },
            {
                path: '/newaccount',
                name: '/newaccount',
                props: true,
                component: () => import('@/views/MyAccount/NewAccount.vue'),
                meta: {
                    title: 'Avenir Software Inc. - Create New Account',
                }
            },
            {
                path: '/forgotpass',
                name: '/forgotpass',
                props: true,
                component: () => import('@/views/MyAccount/ForgotPass.vue'),
                meta: {
                    title: 'Avenir Software Inc. - Forgot Password',
                }
            },
            {
                path: '/account/reset',
                name: '/account/reset',
                meta: {
                    sitemap: { ignoreRoute: true },
                    name: 'robots', content: 'noindex, nofollow',
                },
                component: () => import('@/views/MyAccount/ResetPass.vue'),
            },
            {
                path: '/account/confirm',
                name: '/account/confirm',
                meta: {
                    sitemap: { ignoreRoute: true },
                    name: 'robots', content: 'noindex, nofollow',
                },
                component: () => import('@/views/MyAccount/ConfirmEmail.vue'),
            },
            {
                path: '/contact',
                name: '/contact',
                component: () => import('@/views/Contact.vue'),
                meta: {
                    title: 'Avenir Software Inc. - Contact Us',
                }
            },
            {
                path: '/activation/:productLine',
                name: '/activation/productline',
                props: true,
                meta: {
                    title: 'Avenir Software Inc. - Activation',
                    sitemap: { ignoreRoute: true },
                },
                component: () => import('@/views/Activation.vue'),
            },
            {
                path: '/product/:productLineName/licenseinfo',
                name: 'licenseinfo',
                props: true,
                meta: { sitemap: { ignoreRoute: true }, },
                component: () => import('@/views/Products/LicenseSubscriptionInfo.vue'),
            },
            {
                path: '/product/loopcad',
                name: '/product/loopcad',
                component: () => import('@/views/Products/LoopCAD.vue'),
                meta: {
                    title: 'LoopCAD - Radiant Heating Software',
                    metaTags: [
                        { name: 'description', content: 'LoopCAD is the leading software for radiant heating and snow melt design. Residential heating and cooling load calculations using Manual J, Verified F280 and ASHRAE.' },
                        { name: 'keywords', content: 'software, radiant heating design, snow melt design, HVAC, loopcad, heat loss, heat gain, cooling, calculations, manual j, f280, csa, ashrae, pex, acca approved' },
                    ],
                },
            },
            {
                path: '/product/heatcad',
                name: '/product/heatcad',
                component: () => import('@/views/Products/HeatCAD.vue'),
                meta: {
                    title: 'HeatCAD - Heat Loss Calculation Software',
                    metaTags: [
                        { name: 'description', content: 'HeatCAD provides drawing-based residential heating and cooling load calculations using Manual J, Verified F280 and ASHRAE.' },
                        { name: 'keywords', content: 'software, heating system design, HVAC, heatcad, heat loss, heat gain, cooling, calculations, manual j, f280, csa, ashrae, acca approved' },
                    ],
                },
            },
            {
                path: '/product/plumbingcad',
                name: '/product/plumbingcad',
                component: () => import('@/views/Products/PlumbingCAD.vue'),
                meta: {
                    title: 'PlumbingCAD - Plumbing Design Software',
                    metaTags: [
                        { name: 'description', content: 'PlumbingCAD is a drawing-based software that makes takeoffs and quoting of PEX plumbing systems fast and easy, for both for residential and commercial projects.' },
                        { name: 'keywords', content: 'software, plumbing design, plumbingcad, takeoffs, calculations, pex, autocad, 3D' },
                    ],
                },
            },
            {
                path: '/product/lengthwise',
                name: '/product/lengthwise',
                component: () => import('@/views/Products/LengthWise.vue'),
                meta: {
                    title: 'Lengthwise - Stock Cutting Software',
                },
            },
            {
                path: '/product/custom',
                name: '/product/custom',
                component: () => import('@/views/Products/Custom.vue'),
                meta: {
                    title: 'Custom HVAC Software',
                },
            },
            {
                path: '/store',
                name: '/store',
                props: true,
                component: () => import('@/views/Store/Store.vue'),
                meta: {
                    title: 'Avenir Software Inc. - Purchase Products Online',
                    metaTags: [
                        { name: 'description', content: 'Avenir Software offers a range of products created to meet your heating system design and heat loss calculation needs.' },
                    ],
                },
            },
            {
                path: '/store/confirm/:id',
                name: '/store/confirm',
                props: true,
                meta: {
                    requiresAuth: true,
                    sitemap: { ignoreRoute: true },
                    name: 'robots', content: 'noindex, nofollow',
                },
                component: () => import('@/views/Store/OrderConfirm.vue'),
            },
            {
                path: '/store/confirm-activation/:id',
                name: '/store/confirm-activation',
                props: true,
                meta: {
                    sitemap: { ignoreRoute: true },
                    name: 'robots', content: 'noindex, nofollow',
                },
                component: () => import('@/views/Store/ActivationConfirm.vue'),
            },
            {
                path: '/store/cart',
                name: '/store/cart',
                component: () => import('@/views/Store/Cart.vue'),
            },
            {
                path: '/support/supporthome',
                name: '/support/supporthome',
                props: true,
                component: () => import('@/views/Support/SupportHome.vue'),
                meta: {
                    title: 'Avenir Software Inc. - Support',
                },
            },
            {
                path: '/support/faqs',
                name: '/support/faqs',
                props: true,
                component: () => import('@/views/Support/Faqs.vue'),
                meta: {
                    title: 'Avenir Software Inc. - Frequently Asked Questions',
                    metaTags: [
                        { name: 'description', content: 'Our library of FAQs provides quick access to answeres to the most common question about our products.' },
                    ],
                },
            },
            {
                path: '/support/tutorial',
                name: '/support/tutorial',
                component: () => import('@/views/Support/Tutorials.vue'),
                meta: {
                    title: 'Avenir Software Inc. - Tutorials',
                    metaTags: [
                        { name: 'description', content: 'Check out the online Tutorial lessons. If you are trying to learn a task or feature, this may be your quickest route.' },
                    ],
                },
            },
            {
                path: '/support/webinars',
                name: '/support/webinars',
                component: () => import('@/views/Support/Webinars.vue'),
                meta: {
                    title: 'Avenir Software Inc. - Webinars',
                    metaTags: [
                        { name: 'description', content: 'View training information, including the schedule for upcoming live Webinars. Also download past Webinars.' },
                    ],
                },
            },
            {
                path: '/support/ticket',
                name: '/support/ticket',
                component: () => import('@/views/Support/Ticket.vue'),
                meta: {
                    title: 'Avenir Software Inc. - Submit A Help Ticket',
                    metaTags: [
                        { name: 'description', content: 'The following form is to be used to submit a question or a request for help on any of the Avenir Software products.' },
                    ],
                },
            },
            {
                path: '/support/revisionhistory',
                name: '/support/revisionhistory',
                component: () => import('@/views/Support/RevisionHistory.vue'),
                meta: {
                    title: 'Avenir Software Inc. - Revision History',
                },
            },
            {
                path: '/support/help/enter-activation',
                name: '/support/help/enter-activation',
                component: () => import('@/views/Support/Help/EnterActivation.vue'),
            },
            {
                path: '/support/help/plumbingcad/purchase-prepaid',
                name: '/support/help/plumbingcad/purchase-prepaid',
                component: () => import('@/views/Support/Help/PCADPurchasePrepaid.vue'),
            },
            {
                path: '/support/help/plumbingcad/renew',
                name: '/support/help/plumbingcad/renew',
                component: () => import('@/views/Support/Help/PCADRenew.vue'),
            },
            {
                path: '/support/help/purchase-cc',
                name: '/support/help/purchase-cc',
                component: () => import('@/views/Support/Help/PurchaseCreditCard.vue'),
            },
            {
                path: '/support/help/purchase-prepaid',
                name: '/support/help/purchase-prepaid',
                component: () => import('@/views/Support/Help/PurchasePrepaid.vue'),
            },
            {
                path: '/support/help/autoactivation',
                name: '/support/help/autoactivation',
                component: () => import('@/views/Support/Help/AutoActivation.vue'),
            },
            {
                path: '/support/help/software-activate',
                name: '/support/help/software-activate',
                component: () => import('@/views/Support/Help/SoftwareActivate.vue'),
            },
            {
                path: '/support/help/secondary-activation',
                name: '/support/help/secondary-activation',
                component: () => import('@/views/Support/Help/SecondaryActivation.vue'),
            },
            {
                path: '/support/help/renew',
                name: '/support/help/renew',
                component: () => import('@/views/Support/Help/Renew.vue'),
            },
            {
                path: '/support/help/troubleshoot',
                name: '/support/help/troubleshoot',
                component: () => import('@/views/Support/Help/Troubleshoot.vue'),
            },
            {
                path: '/support/help/upgrade',
                name: '/support/help/upgrade',
                component: () => import('@/views/Support/Help/Upgrade.vue'),
            },
            {
                path: '/support/help/account-activate',
                name: '/support/help/account-activate',
                component: () => import('@/views/Support/Help/AccountActivate.vue'),
            },
            {
                path: '/support/help/expiry-sync-date',
                name: '/support/help/expiry-sync-date',
                component: () => import('@/views/Support/Help/ExpirySyncDate.vue'),
            },
            {
                path: '/download/:productLine',
                name: '/download',
                props: true,
                meta: {
                    sitemap: { ignoreRoute: true },
                    title: 'Avenir Software Inc. - Downloads',
                    metaTags: [
                        { name: 'description', content: 'Check this section for the latest updates and maintenance releases. Additional resources may also be available here for download.' },
                    ],
                },
                component: () => import('@/views/Downloads/Downloads.vue'),
            },
            {
                path: '/download/loopcad/uponor',
                name: '/download/loopcad/uponor',
                component: () => import('@/views/Downloads/UponorLanding.vue'),
            },
            {
                path: '/download/:productLine/:oem',
                name: '/download/productLine/oem',
                props: true,
                meta: {
                    sitemap: { ignoreRoute: true },
                    title: 'Avenir Software Inc. - Download',
                },
                component: () => import('@/views/Downloads/FileDownload.vue'),
            },
            {
                path: '/archived/download/:productLine',
                name: 'archived/download/productLine',
                props: true,
                meta: {
                    sitemap: { ignoreRoute: true },
                    title: 'Avenir Software Inc. - Archived Downloads',
                },
                component: () => import('@/views/Downloads/ArchivedDownloads.vue'),
            },
            {
                path: '/news',
                name: '/news',
                component: () => import('@/views/News.vue'),
                meta: {
                    title: 'Avenir Software Inc. - News',
                }
            },
            {
                path: '/news/article/:id',
                name: '/news/article',
                props: true,
                meta: { sitemap: { ignoreRoute: true } },
                component: () => import('@/views/Article.vue'),
                meta: {
                    title: 'Avenir Software Inc. - News',
                }
            },
            {
                path: '/privacy',
                name: '/privacy',
                component: () => import('@/views/Legal/Privacy.vue'),
                meta: {
                    title: 'Avenir Software Inc. - Privacy Policy',
                }
            },
            {
                path: '/terms',
                name: '/terms',
                component: () => import('@/views/Legal/Terms.vue'),
                meta: {
                    title: 'Avenir Software Inc. - Terms & Conditions',
                }
            },
            {
                path: '/eula/loopcad',
                name: '/eula/loopcad',
                component: () => import('@/views/Legal/EULA/LoopCAD.vue'),
            },
            {
                path: '/eula/heatcad',
                name: '/eula/heatcad',
                component: () => import('@/views/Legal/EULA/HeatCAD.vue'),
            },
            {
                path: '/eula/plumbingcad',
                name: '/eula/plumbingcad',
                component: () => import('@/views/Legal/EULA/PlumbingCAD.vue'),
            },
            {
                path: '/about',
                name: '/about',
                component: () => import('@/views/About.vue'),
                meta: {
                    title: 'Avenir Software Inc. - About Us',
                }
            },
            {
                path: '/acca',
                name: '/acca',
                component: () => import('@/views/ACCA.vue'),
                meta: {
                    title: 'ACCA Approved Manual J Software',
                    metaTags: [
                        { name: 'description', content: 'HeatCAD and LoopCAD now provide ACCA-Approved Manual J residential heating and cooling load calculations.' },
                        { name: 'keywords', content: 'acca, acca-approved, manual j, software,  HVAC, radiant heating design, loopcad, heatcad, heat loss, heat gain, heating load, coolingload, calculations' }
                    ],
                },
            },
            {
                path: '/f280',
                name: '/f280',
                component: () => import('@/views/F280.vue'),
                meta: {
                    title: 'Verified F280 - Heat Loss / Heat Gain Software',
                    metaTags: [
                        { name: 'description', content: 'Verified F280-12 residential heating and cooling load calculations using HeatCAD and LoopCAD.' },
                        { name: 'keywords', content: 'F280, CSA, software, HVAC, radiant heating design, loopcad, heatcad, heat loss, heat gain, heating load, cooling load, calculations' },
                    ],
                },
            },

        ]
    },
    {
        path: '/autoactivation',
        name: '/autoactivation',
        component: () => import('@/views/AutoActivation.vue'),
        meta: {
            metaTags: [
                { 'http-equiv': 'Cache-Control', content: 'no-store, no-cache, must-revalidate' },
                { 'http-equiv': 'Pragma', content: 'no-cache' },
                { 'http-equiv': 'Expires', content: '0' },
            ],
        },
    },
    {
        path: '/retrieveactivationcode',
        name: '/retrieveactivationcode',
        component: () => import('@/views/RetrieveActivationCode.vue'),
    },
    {
        path: '/maintenance',
        name: '/maintenance',
        component: () => import('@/views/Maintenance.vue'),
    },

]

// Always leave this as last one
if (process.env.MODE !== 'ssr') {
    routes.push({
        path: '*',
        component: () => import('@/views/404.vue')
    })
}

export default routes
